export default __webpack_public_path__ + "static/media/verlinde-health-app.6e634212.png";